import {FormProps, getTimeFromDate} from 'platform/components';

import {
  GetTireSetApiResponse,
  GetTireSetLocationResponse,
  GetTireSetRequestApiResponse,
} from '@dms/api/core';
import {PhoneNumber} from '@dms/api/shared';

import {parseDate, getApiDateString, Nullish} from 'shared/web';

import {TireSetDetailFormDefinition} from '../types/TireSetDetailFormDefinition';

// eslint-disable-next-line complexity -- Pre-existing violation
export const getEditTireSetDefaultValues = (
  tenantPhoneInfo: PhoneNumber,
  tireSet: GetTireSetApiResponse,
  defaultCategoryId: string | Nullish,
  tireSetLocation?: GetTireSetLocationResponse,
  tireSetRequest?: GetTireSetRequestApiResponse
): FormProps<TireSetDetailFormDefinition>['defaultValues'] => ({
  contactInformation: {
    id: tireSet?.contactInformation?.id,
    contactId: tireSet?.contactInformation?.contactId,
    name: tireSet?.contactInformation?.name,
    email: tireSet?.contactInformation?.email,
    phoneNumber: {
      number: tireSet?.contactInformation?.phoneNumber?.number?.toString(),
      prefix: tireSet?.contactInformation?.phoneNumber?.prefix ?? tenantPhoneInfo.prefix,
      countryCode:
        tireSet?.contactInformation?.phoneNumber?.countryCode ?? tenantPhoneInfo.countryCode,
    },
  },
  storedLocation: tireSetLocation?.location,
  storedUntil: tireSet?.storedUntil ? getApiDateString(parseDate(tireSet?.storedUntil)) : undefined,
  numberOfTires: tireSet?.wheels?.filter((wheel) => wheel?.state !== 'ARCHIVED')?.length,
  note: tireSet?.note,
  categoryId: tireSet?.categoryId ?? defaultCategoryId,
  isReplacement: tireSet?.isReplacement ?? false,

  wheels:
    tireSet?.wheels
      ?.filter((wheel) => wheel?.state !== 'ARCHIVED')
      // eslint-disable-next-line complexity -- Pre-existing violation
      ?.map((wheel) => ({
        checked: true,
        id: wheel?.id,
        aspectRatio: wheel?.wheelDetails?.aspectRatio,
        dot: wheel?.wheelDetails?.dot,
        li: wheel?.wheelDetails?.li,
        location: wheel?.wheelDetails?.location,
        manufacturer: wheel?.wheelDetails?.manufacturer,
        note: wheel?.wheelDetails?.note,
        rim: wheel?.wheelDetails?.rim,
        rimType: wheel?.wheelDetails?.rimType,
        season: wheel?.wheelDetails?.season,
        sr: wheel?.wheelDetails?.sr,
        tireWidth: wheel?.wheelDetails?.tireWidth,
        tread: wheel?.wheelDetails?.tread,
        title: wheel?.wheelDetails?.title,
        hasHubcap: wheel?.wheelDetails?.hasHubcap ?? false,
        hasWheelLocks: wheel?.wheelDetails?.hasWheelLocks ?? false,
        tireCondition: wheel?.wheelDetails?.tireCondition,
      })) ?? [],

  destinationBranchId: tireSetRequest?.destinationBranchId,
  neededAtDate: tireSetRequest?.neededAt
    ? getApiDateString(parseDate(tireSetRequest.neededAt))
    : undefined,
  neededAtTime: tireSetRequest?.neededAt
    ? getTimeFromDate(parseDate(tireSetRequest.neededAt))
    : '07:00',
  requestNote: tireSetRequest?.note || '',
  tireSetRequestEnabled: !!tireSetRequest,
});
